import styled from "styled-components";

export const FullWidth = styled.div`
  grid-column: 1 / -1;
`;